import { useAuthentication } from 'src/features/authentication/context';
import { Protected } from 'src/features/protected-route/components';
import { ACCOUNT_ISSUE_PATH, LOGIN_PATH } from '../../config';
import { AppLayout } from 'src/layouts';
import {
  NAV_ITEMS_HEADER_SITES_MANAGEMENT,
  getNavItemsHeaderSiutesManagementSAAndAA,
} from 'src/features';
import { ElementProps } from '../../types/element';
import { LoadingElement } from '../LoadingElement';
import { AccessRoles } from 'src/features/user-account-details/types';
import { PreviewDashboard } from 'src/features/customDashboard/pages';

export const PreviewDashboardElement = ({ isSuperAdmin }: ElementProps) => {
  const { isCustomerAccessAllowed, loggedIn, customerId, getCurrentRole, user } =
    useAuthentication();

  const isAccountAdmin = getCurrentRole(customerId.value, null) === AccessRoles.ACCOUNT_ADMIN;

  const getUniqueRedirectPath = () => {
    if (!loggedIn.value) return LOGIN_PATH;
    if (!isCustomerAccessAllowed.value) return ACCOUNT_ISSUE_PATH + '?reason=Access Denied';
  };

  const DashboardRouteElement = () => (
    <Protected
      isAuthenticated={loggedIn.value}
      isAuthorized={isSuperAdmin || isCustomerAccessAllowed.value}
      uniqueRedirectPath={getUniqueRedirectPath()}
    >
      <AppLayout
        hideSiteHeader={true}
        headerTitle=""
        headerNavItems={
          isSuperAdmin || isAccountAdmin
            ? getNavItemsHeaderSiutesManagementSAAndAA(user, isSuperAdmin)
            : NAV_ITEMS_HEADER_SITES_MANAGEMENT
        }
      >
        <PreviewDashboard />
      </AppLayout>
    </Protected>
  );

  const getDashboardElement = () => {
    if (!loggedIn.loaded) return <LoadingElement />;

    if (loggedIn.loaded && !loggedIn.value) return <DashboardRouteElement />;

    if (!customerId.value || !customerId.loaded) return <LoadingElement />;

    if (isSuperAdmin && loggedIn.loaded) return <DashboardRouteElement />;

    if (!isCustomerAccessAllowed.loaded) return <LoadingElement />;

    return <DashboardRouteElement />;
  };

  return getDashboardElement();
};
